import * as EQSize from '@/class/cargo/model/parameters/EQSize'
import { PoItems } from '@/class/model/booking/PoItems'
import {
  AbstractEntity as SeaEQ,
  AbstractEntity as Container,
  AbstractEntity as ContainerUsage
} from '@/class/model/AbstractEntity'
import { deepClone } from '@/utils'

/**
 * 港区同步字段
 * @type {string[]}
 */
export const SYNC_PORT_FIELDS = ['wharfStowage', 'wharfReleaseDate', 'wharfStowageState', 'customReleaseDate', 'destinationReturnTime',
  'approachDate', 'playDate', 'plateApproachDate', 'platePlayDate']

export class PortDataCompareUtils {
  // 新增箱货数据
  static addNewContainerUsages(eve, newUsagesMap) {
    // 需要新增箱货信息
    const eqSizeModel = EQSize.getEQSizeByCode(eve.eqSize)
    const eqSize = (eqSizeModel === null) ? '' : eqSizeModel.code
    const poItems = new PoItems().fillDefaultValue().getData()
    poItems.purchaseCurrency = 'USD'
    poItems.deviceStatus = 0
    poItems.productiveYear = '不详'
    poItems.newOrUsed = ''
    poItems.jobUuid = eve.jobUuid
    poItems.containerNo = eve.containerNo
    poItems.eqSize = eve.eqSize
    poItems.eqType = eve.eqType
    poItems.sealNo = eve.sealNo
    poItems.quantity = eve.quantity
    poItems.grossWeight = eve.weight
    poItems.cubage = eve.cubage
    poItems.soNo = eve.soNo
    poItems.related = 1
    poItems.containerUsageKey = eve.containerUsageKey
    if (!newUsagesMap.hasOwnProperty(poItems.containerNo)) {
      const newContainerUsage = new ContainerUsage().fillDefaultValue().getData()
      const newContainer = new Container().fillDefaultValue().getData()
      newContainer.containerNo = eve.containerNo
      newContainer.eqSize = eqSize
      newContainer.eqType = eve.eqType
      newContainer.sealNo = eve.sealno
      newContainer.jobUuid = eve.jobUuid
      newContainer.confirmed = 11
      newContainer.isDirty = true
      const seaEQ = new SeaEQ().fillDefaultValue().getData()
      seaEQ.containerNo = eve.containerNo
      seaEQ.eqSize = eqSize
      seaEQ.eqType = eve.eqType
      seaEQ.sealNo = eve.sealNo
      seaEQ.eqQuantity = 1
      seaEQ.jobUuid = eve.jobUuid
      newContainerUsage.type = '新增'
      newContainerUsage.quantity = 0
      newContainerUsage.weight = 0
      newContainerUsage.cubage = 0
      PortDataCompareUtils.syncPortDate(eve, newContainer)
      newContainerUsage.jobUuid = eve.jobUuid
      newContainerUsage.eqSize = eqSize
      newContainerUsage.eqType = eve.eqType
      newContainerUsage.containerNo = eve.containerNo
      newContainerUsage.sealNo = eve.sealno
      newContainerUsage.container = newContainer
      newContainerUsage.seaEQ = seaEQ
      newContainerUsage.confirmed = 11
      PortDataCompareUtils.syncPortDate(eve, newContainerUsage)
      newContainerUsage.poItems = []
      newUsagesMap[poItems.containerNo] = newContainerUsage
    }
    const containerUsage = newUsagesMap[poItems.containerNo]
    containerUsage.quantity = containerUsage.quantity + eve.quantity
    containerUsage.weight = containerUsage.weight + eve.weight
    containerUsage.cubage = containerUsage.cubage + eve.cubage
    containerUsage.poItems.push(poItems)
  }
  static removeHarbourData(harbourList, harbourSource) {
    if (harbourList.length > 0) {
      harbourList.forEach(e => {
        harbourSource.forEach((eve, index) => {
          if (e === eve.uuid) {
            harbourSource.splice(index, 1)
          }
        })
      })
    }
  }
  // 处理箱货与商品的关联关系
  static initContainerPoItems(containerUsages, poItems) {
    if (containerUsages && containerUsages.length > 0) {
      const poItemMap = {}
      // 商品信息根据containerUsageKey分map
      if (poItems && poItems.length > 0) {
        poItems.forEach(item => {
          if (item.weight && !item.grossWeight) {
            item.grossWeight = item.weight
          }
          if (!poItemMap.hasOwnProperty(item.containerUsageKey)) {
            poItemMap[item.containerUsageKey] = []
          }
          poItemMap[item.containerUsageKey].push(item)
        })
      }
      // 循环遍历箱货明细，将poItem绑定
      containerUsages.forEach(item => {
        // 解决，同一个 没有uuid的关单信息 同时装进多个箱子的场景（整箱）
        if (item.uuid) {
          item.poItems = []
          if (poItemMap.hasOwnProperty(item.uuid)) {
            item.poItems = item.poItems.concat(poItemMap[item.uuid])
          }
        }
      })
    }
  }

  // 处理箱货与商品的关联关系
  static initContainerPoItemsMultiSoNoMode(containerUsages, poItems, jobUuid) {
    if (containerUsages && containerUsages.length > 0) {
      const poItemMap = {}
      const addPoItems = []
      // 商品信息根据containerUsageKey分map
      if (poItems && poItems.length > 0) {
        poItems.forEach(item => {
          if (item.weight && !item.grossWeight) {
            item.grossWeight = item.weight
          }
          if (item.containerUsageKey) {
            if (!poItemMap.hasOwnProperty(item.containerUsageKey)) {
              poItemMap[item.containerUsageKey] = []
            }
            poItemMap[item.containerUsageKey].push(item)
          } else {
            addPoItems.push(item)
          }
        })
      }
      // 循环遍历箱货明细，将poItem绑定
      containerUsages.forEach(item => {
        if (poItemMap.hasOwnProperty(item.uuid)) {
          item.poItems = []
          item.poItems = item.poItems.concat(poItemMap[item.uuid])
          // 【关单信息】页签需要将这些poItems排查掉，否则创建重复
          item.poItems.forEach(p => { p.existInUsagedFlag = true })
        }
      })
      // 新增业务时，只有一个箱子时，装进去（编辑时，只有一个箱子时，有些关单信息不要装箱，要装箱的都已经赋了containerUsageKey了，会通过上面的逻辑赋值到箱子里）
      if (!jobUuid && containerUsages.length === 1 && addPoItems.length > 0) {
        containerUsages[0].poItems = addPoItems
        // 【关单信息】页签需要将这些poItems排查掉，否则创建重复
        addPoItems.forEach(p => { p.existInUsagedFlag = true })
      }
    }
  }

  /**
   * 相加
   * @param value1
   * @param value2
   * @param isInt 是否int类型
   */
  static adding(value1, value2, isInt) {
    if (!value1 && !value2) {
      return 0
    }
    if (!value1) {
      return value2
    }
    if (!value2) {
      return value1
    }
    if (isInt) {
      return parseInt(value1) + parseInt(value2)
    }
    return parseFloat(value1) + parseFloat(value2)
  }

  /**
   * 校验箱量是否一致
   * @param source
   * @param target
   * @returns {boolean}
   */
  static checkEqSize(source, target) {
    if (source === target) {
      return true
    }
    const eqSizeModel = EQSize.getEQSizeByName(source)
    const eqSize = (eqSizeModel === null) ? '' : eqSizeModel.code
    return eqSize === target
  }

  /**
   * 校验值转换
   * @param type
   * @returns {number}
   */
  static getConfirmed(type) {
    switch (type) {
      case '新增':
        return 11
      case '修改':
        return 12
      case '保持':
        return 13
      default:
        return 0
    }
  }

  /**
   * 新增拼箱箱子信息
   * @param eve
   * @param newContainers
   * @param jobUuid
   * @param lclSlaveSoNo
   */
  static addLclContainer(eve, newContainers, jobUuid, lclSlaveSoNo) {
    // 需要新增箱货信息
    const eqSizeModel = EQSize.getEQSizeByName(eve.eqSize)
    const eqSize = (eqSizeModel === null) ? '' : eqSizeModel.code
    if (!newContainers.hasOwnProperty(eve.containerNo)) {
      const newContainer = new Container().fillDefaultValue().getData()
      newContainer.containerNo = eve.containerNo
      newContainer.type = '新增'
      newContainer.eqSize = eqSize
      newContainer.eqType = eve.eqType
      newContainer.sealNo = eve.sealno
      newContainer.jobUuid = jobUuid
      newContainer.confirmed = 11
      newContainer.quantity = 0
      newContainer.weight = 0.000
      newContainer.cubage = 0.000
      PortDataCompareUtils.syncPortDate(eve, newContainer)
      const seaEQ = new SeaEQ().fillDefaultValue().getData()
      seaEQ.containerNo = eve.containerNo
      seaEQ.eqSize = eqSize
      seaEQ.eqType = eve.eqType
      seaEQ.sealNo = eve.sealno
      seaEQ.eqQuantity = 1
      seaEQ.jobUuid = jobUuid
      newContainer.containerUsage = []
      newContainer.seaEQ = seaEQ
      newContainers[eve.containerNo] = newContainer
    }
    const container = newContainers[eve.containerNo]
    container.quantity = container.quantity + eve.quantity
    container.weight = container.weight + eve.weight
    container.cubage = container.cubage + eve.cubage
    const usage = this.addLclContainerUsage('新增', eve, lclSlaveSoNo)
    container.containerUsage.push(usage)
  }

  /**
   * 新增拼箱装箱信息
   * @param type
   * @param eve
   * @param lclSlaveSoNo
   */
  static addLclContainerUsage(type, eve, lclSlaveSoNo) {
    const eqSizeModel = EQSize.getEQSizeByName(eve.eqSize)
    const eqSize = (eqSizeModel === null) ? '' : eqSizeModel.code
    const newContainerUsage = new ContainerUsage().fillDefaultValue().getData()
    Object.assign(newContainerUsage, deepClone(lclSlaveSoNo[eve.soNo]))
    newContainerUsage.uuid = ''
    newContainerUsage.type = type
    newContainerUsage.quantity = eve.quantity
    newContainerUsage.weight = eve.weight
    newContainerUsage.cubage = eve.cubage
    newContainerUsage.eqSize = eqSize
    newContainerUsage.eqType = eve.eqType
    newContainerUsage.containerNo = eve.containerNo
    newContainerUsage.sealNo = eve.sealno
    newContainerUsage.confirmed = 11
    newContainerUsage.jobUuid = lclSlaveSoNo[eve.soNo].uuid
    newContainerUsage.jobNo = lclSlaveSoNo[eve.soNo].jobNo
    newContainerUsage.soNo = eve.soNo
    return newContainerUsage
  }

  /**
   * 新增装箱信息SeaEq
   * @param seaEQs
   * @param eqType
   * @param eqSize
   */
  static addSeaEQ(seaEQs, eqType, eqSize) {
    if (!seaEQs || seaEQs.length === 0) {
      seaEQs = []
    }
    for (const seaEQ of seaEQs) {
      if (seaEQ.eqSize === eqSize && seaEQ.eqType === eqType) {
        seaEQ.eqQuantity = seaEQ.eqQuantity + 1
        seaEQ.isDirty = true
        return
      }
    }
    const newSeaEQ = new SeaEQ().fillDefaultValue().getData()
    newSeaEQ.eqSize = eqSize
    newSeaEQ.eqType = eqType
    newSeaEQ.eqQuantity = 1
    newSeaEQ.isDirty = true
    newSeaEQ.jobUuid = seaEQs[0].jobUuid
    seaEQs.push(newSeaEQ)
  }

  /**
   * 新增装箱信息SeaEq
   * @param seaEQs
   * @param eqType
   * @param eqSize
   */
  static changeSeaEQ(seaEQs, sourceEqSize, sourceEqType, targetEqSize, targetEqType, job) {
    if (!seaEQs || seaEQs.length === 0) {
      return
    }
    const seas = seaEQs.filter(item => item.eqSize === sourceEqSize && item.eqType === sourceEqType)
    if (!seas || seas.length === 0) {
      return
    }
    const sea = seas[0]
    // 如果原数量为1 则直接修改 seqEQ的箱型箱种
    if (sea.eqQuantity === 1) {
      // 如果已经有目标箱量箱种，则将当前的去除，将目标+1
      const targetSeas = seaEQs.filter(item => item.eqSize === targetEqSize && item.eqType === targetEqType)
      if (!targetSeas || targetSeas.length === 0) { // 目标箱型箱量没有，则直接修改原箱型箱量
        sea.eqSize = targetEqSize
        sea.eqType = targetEqType
        sea.isDirty = true
        return
      }
      // 目标有，则直接在目标上+1
      targetSeas[0].eqQuantity += 1
      // 删除原来的
      if (!job.delseaEQUuids) {
        job.delseaEQUuids = []
      }
      if (sea.uuid) {
        job.delseaEQUuids.push(sea.uuid)
      }
      const index = seaEQs.indexOf(sea)
      seaEQs.splice(index, 1)
      return
    }

    // 如果原数量大于1 则将 seqEQ的原数量 -1，再继续查找是否有target箱型箱种，若有，则将改seaEQ的数量+1
    sea.eqQuantity = sea.eqQuantity - 1
    const targetSeas = seaEQs.filter(item => item.eqSize === targetEqSize && item.eqType === targetEqType)
    if (!targetSeas || targetSeas.length === 0) {
      // 新增箱型箱种seqEQ
      const newSeaEQ = new SeaEQ().fillDefaultValue().getData()
      newSeaEQ.eqSize = targetEqSize
      newSeaEQ.eqType = targetEqType
      newSeaEQ.eqQuantity = 1
      newSeaEQ.isDirty = true
      newSeaEQ.jobUuid = seaEQs[0].jobUuid
      seaEQs.push(newSeaEQ)
      return
    }
    const targetSea = targetSeas[0]
    targetSea.eqQuantity = targetSea.eqQuantity + 1
  }

  /**
   * 同步港区日期
   *  校验新值不为空才覆盖
   */
  static syncPortDate(source, target) {
    for (const syncPortField of SYNC_PORT_FIELDS) {
      if (source[syncPortField]) {
        target[syncPortField] = source[syncPortField]
      }
    }
  }

  /**
   * 港区箱种转换
   * @param eqType 箱种
   * @param containerHeightCn 箱高度中文
   * @returns {string[]|*}
   */
  static transformEqType(eqType, containerHeightCn, HQHCFlag) {
    if (eqType + containerHeightCn === 'RF9\'6\'\'') {
      return ['RH']
    }
    if (containerHeightCn === '8\'6\'\'') {
      // CARGO-32037 数据服务-数据对比中箱种港区返回的与实际不符合
      return [eqType]
    }
    if ((eqType + containerHeightCn) === 'GP9\'6\'\'') {
      return ['HQ', 'HC']
    }
    if ((eqType === 'HQ' || eqType === 'HC') && !containerHeightCn && !HQHCFlag) {
      return ['HQ', 'HC']
    }
    return [eqType]
  }

  /**
   * 当前箱号有系统校验的值，且存在未校验的值
   * @param containerNo
   * @param list
   * @returns {boolean}
   */
  static systemVerificationHasNotConfirm(containerNo, list) {
    if (!containerNo) {
      return false
    }
    for (const data of list) {
      if (data.containerNo === containerNo && data.confirmed === 0) {
        return true
      }
    }
    return false
  }
}
